import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface FiltersInitialState {
  cityIdOnDeliverymanList?: string;
  deliveryTypeOnDeliverymanList?: string;
  cityIdOnPlacesList?: string;
  deliveryTypeOnPlacesList?: string;
  cityIdOnDeliveriesList?: string;
  deliveryTypeOnDeliveriesList?: string;
  cityIdOnApprovalsList?: string;
  cityIdOnDashboard?: string;
  cityIdOnMissionsList?: string;
  cityIdOnMonitor?: string;
}

const FILTERS_INITIAL_STATE: FiltersInitialState = {
  cityIdOnDeliverymanList: undefined,
  deliveryTypeOnDeliverymanList: undefined,
  cityIdOnPlacesList: undefined,
  deliveryTypeOnPlacesList: undefined,
  cityIdOnDeliveriesList: undefined,
  deliveryTypeOnDeliveriesList: undefined,
  cityIdOnApprovalsList: undefined,
  cityIdOnDashboard: undefined,
  cityIdOnMissionsList: undefined,
  cityIdOnMonitor: undefined,
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState: FILTERS_INITIAL_STATE,
  reducers: {
    setFilterCityOnDeliverymanList(
      state,
      action: PayloadAction<string | undefined>,
    ) {
      state.cityIdOnDeliverymanList = action.payload;
    },
    setFilterDeliveryTypeOnDeliverymanList(
      state,
      action: PayloadAction<string | undefined>,
    ) {
      state.deliveryTypeOnDeliverymanList = action.payload;
    },
    setFilterCityOnPlacesList(state, action: PayloadAction<string>) {
      state.cityIdOnPlacesList = action.payload;
    },
    setFilterDeliveryTypeOnPlacesList(
      state,
      action: PayloadAction<string | undefined>,
    ) {
      state.deliveryTypeOnPlacesList = action.payload;
    },
    setFilterCityOnDeliveriesList(state, action: PayloadAction<string>) {
      state.cityIdOnDeliveriesList = action.payload;
    },
    setFilterDeliveryTypeOnDeliveriesList(
      state,
      action: PayloadAction<string | undefined>,
    ) {
      state.deliveryTypeOnDeliveriesList = action.payload;
    },
    setFilterCityOnApprovalsList(state, action: PayloadAction<string>) {
      state.cityIdOnApprovalsList = action.payload;
    },
    setFilterCityOnDashboard(state, action: PayloadAction<string | undefined>) {
      state.cityIdOnDashboard = action.payload;
    },
    setFilterCityOnMissionsList(state, action: PayloadAction<string>) {
      state.cityIdOnMissionsList = action.payload;
    },
    setFilterCityOnMonitor(state, action: PayloadAction<string | undefined>) {
      state.cityIdOnMonitor = action.payload;
    },
  },
});

export const {
  setFilterCityOnDeliverymanList,
  setFilterDeliveryTypeOnDeliverymanList,
  setFilterCityOnApprovalsList,
  setFilterCityOnDeliveriesList,
  setFilterCityOnPlacesList,
  setFilterDeliveryTypeOnDeliveriesList,
  setFilterDeliveryTypeOnPlacesList,
  setFilterCityOnDashboard,
  setFilterCityOnMissionsList,
  setFilterCityOnMonitor,
} = filtersSlice.actions;

export const filtersReducer = filtersSlice.reducer;
